import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import {
  IMemberEvent,
  IMemberEventBooking,
  IMemberEventsDate,
} from '@shared/shared/interfaces/member-event.interfaces';
import * as fromMemberEventBooking from './member-event-booking.reducer';
import * as fromMemberEventDate from './member-event-date.reducer';
import * as fromMemberEvent from './member-event.reducer';

export interface MemberEventState {
  memberEvent: IMemberEvent;
  memberEventBooking: IMemberEventBooking;
  memberEventDate: IMemberEventsDate;
}

export const reducers: ActionReducerMap<MemberEventState> = {
  memberEvent: fromMemberEvent.reducer,
  memberEventBooking: fromMemberEventBooking.reducer,
  memberEventDate: fromMemberEventDate.reducer,
};

export const getMemberEventState = createFeatureSelector<MemberEventState>('member-event');
